<mat-card>طلبات الخدمات</mat-card>



<div class="container" style="padding: 25px;">


    <mat-grid-list cols="6" rowHeight="50px">

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard" class="example-form-field" style="margin: 10px;;">
                <mat-label>{{'status' | translate}}</mat-label>
                <mat-select [(value)]="selectedStatus" (selectionChange)="getServiceOrders()">
                    <mat-option *ngFor="let item of chargedStatus" [value]="item.id">
                        {{item.name | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'user' | translate}}</mat-label>
                <input type="text" matInput [formControl]="userControl" [matAutocomplete]="auto">
                <button mat-button matSuffix mat-icon-button>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                    (optionSelected)="selectUserChange($event.option.value)">
                    <mat-option *ngFor="let item of filteredOptions | async" [value]="item">
                        {{item.userName}}
                        {{item.userName != null && item.fullName != null ? '-' : ""}}
                        {{item.fullName}}
                    </mat-option>
                </mat-autocomplete>
                <button type="button" mat-button *ngIf="selectedUserId != ''" matSuffix mat-icon-button
                    aria-label="Clear" (click)="clearUser()">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="userControl.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard" class="example-form-field">
                <mat-label>{{'enterDateRange' | translate}}</mat-label>
                <mat-date-range-input [rangePicker]="rangePicker">
                    <input matStartDate placeholder="Start date" #fromDate>
                    <input matEndDate placeholder="End date" #toDate>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
                        <button mat-raised-button color="primary" matDateRangePickerApply>{{'ok'
                            |
                            translate}}</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'filter' | translate}}</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <button mat-raised-button color="primary" (click)="onSearch()" style="margin-left: 10px;">
                <mat-icon>search</mat-icon>
                {{'filter' | translate}}
            </button>
        </mat-grid-tile>

    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'orderNo' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'dateTime' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.date}} </td>
            </ng-container>

            <ng-container matColumnDef="userFullName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'fullName' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.userFullName}} </td>
            </ng-container>

            <ng-container matColumnDef="subServiceName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'product' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.subServiceName}} </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> {{'view' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="viewFields(row)">
                        <mat-icon>view_list</mat-icon>
                    </button>

                    <button mat-icon-button (click)="onDone(row)" *ngIf="row.status == 0">
                        <mat-icon>done</mat-icon>
                    </button>

                    <button mat-icon-button (click)="onReject(row)" *ngIf="row.status == 0">
                        <mat-icon>replay</mat-icon>
                    </button>
                </td>
            </ng-container>







            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}</td>
            </tr>
        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>

<!-- <ng-template #Modal>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>{{'areYouSureToDelete' | translate}}</p>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-button cdkFocusInitial>{{'yes' | translate}}</button>
    </div>

</ng-template> -->

<ng-template #ModalView>

    <h1 mat-dialog-title dir="rtl">البيانات</h1>
    <div mat-dialog-content dir="rtl">
        <hr />
        <div align="center" style="font-weight: 900;color: green;" *ngIf="serviceOrders.mainServiceType == 2">
            <label>{{'amount' | translate}} : {{serviceOrders.amount}}</label>
        </div>

        <table mat-table [dataSource]="dataSourceOrderValue">

            <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef> {{'label' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.label}} </td>
            </ng-container>

            <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef> {{'value' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.value}} </td>
            </ng-container>

            <ng-container matColumnDef="copy">
                <th mat-header-cell *matHeaderCellDef> {{'copy' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="copy(row.value)">
                        <mat-icon>file_copy</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsOrderValue"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsOrderValue;"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}</td>
            </tr>
        </table>
    </div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close (click)="onNoClick()">Close</button>
    </div>

</ng-template>


<ng-template #ModalConfirmReject>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>{{'areYouSureToReject' | translate}}</p>
        <mat-form-field appearance="standard">
            <mat-label>{{'rejectReason' | translate}}</mat-label>
            <textarea matInput [(ngModel)]="rejectReason"></textarea>
        </mat-form-field>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-raised-button color="primary" cdkFocusInitial (click)="confirmReject()">{{'yes' |
            translate}}</button>
    </div>

</ng-template>